import React from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import { bool, func, object } from 'prop-types';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: ${({ open }) => ((open) ? 'block' : 'none')};
  z-index: 99;
`;

const Container = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  position: relative;
  width: 250px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  padding: 32px;
  text-align: center;
  border-radius: 5px;

  @media(min-width: 1000px) {
    width: 536px;
  }
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: #4a4a4a;

  @media(min-width: 1000px) {
    font-size: 24px;
  }
`;

const Content = styled(ReactMarkdown)`
  margin-top: 16px;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  color: #4a4a4a;
  margin-bottom: 16px;
  strong {
    font-weight: 700;
  }

  @media(min-width: 1000px) {
    font-size: 16px;
  }
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;

  @media(min-width: 1000px) {
    flex-direction: row;
    justify-content: space-evenly;
  }
`;

const LeaveButton = styled.a`
  cursor: pointer;
  width: 250px;
  line-height: 2.4;
  height: 40px;
  border-radius: 100px;
  font-size: 16px;
  text-align: center;
  color: #f78323;
  background-color: #ffffff;
  border: 1px solid #f78323;
  margin: 10px 0;

  @media(min-width: 1000px) {
    width: 204px;
  }
`;

const ContinueButton = styled.button`
  cursor: pointer;
  width: 250px;
  line-height: 1.5;
  height: 40px;
  border-radius: 100px;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
  background-color: #f78323;
  border: none;

  @media(min-width: 1000px) {
    width: 204px;
  }
`;

const ConfirmationModal = ({
  open, onClose, content = {},
}) => (
  <Overlay open={open}>
    <Container data-e2e="modal-container">
      <Title>{content.title}</Title>
      <Content>
        {content.text}
      </Content>
      <Footer>
        <LeaveButton href={content.leaveButtonLink}>{content.leaveButton}</LeaveButton>
        <ContinueButton onClick={onClose}>{content.continueButton}</ContinueButton>
      </Footer>
    </Container>
  </Overlay>
);

ConfirmationModal.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
  content: object,
};

ConfirmationModal.defaultProps = {
  content: {},
};

export default ConfirmationModal;
